import { render, staticRenderFns } from "./copy_icon.vue?vue&type=template&id=63e0fc48&"
import script from "./copy_icon.vue?vue&type=script&lang=js&"
export * from "./copy_icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports